import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { Reveal } from '@/components/generals/reveal'
import { Ruler } from '@/components/generals/ruler'

import { PROOFS } from '@/constants/content'

export const ProofBand: FC = (): ReactNode => {
    return (
        <section data-theme='ink' aria-labelledby='engagements-title' className='bg-background text-foreground'>
            <Container className='py-14 lg:py-20'>
                <div className='flex items-end justify-between gap-6'>
                    <h2 id='engagements-title' className='label-mono text-muted-foreground'>
                        Nos engagements, écrits noir sur blanc
                    </h2>

                    <p aria-hidden='true' className='label-mono hidden text-muted-foreground sm:block'>
                        Réf. KRM / 2026
                    </p>
                </div>

                <Ruler className='mt-5 text-border' />

                <Reveal>
                    <ul className='grid grid-cols-2 gap-x-5 gap-y-10 pt-10 lg:grid-cols-4 lg:gap-x-0'>
                        {PROOFS.map((proof, index) => (
                            <li key={proof.title} className='flex flex-col border-l border-border pl-4 sm:pl-6 lg:pr-6'>
                                <span className='label-mono text-signal-text'>
                                    {String(index + 1).padStart(2, '0')}
                                </span>

                                <p className='heading mt-4 text-figure tabular-nums'>
                                    {proof.figure}
                                </p>

                                <h3 className='mt-3 font-semibold leading-snug'>
                                    {proof.title}
                                </h3>

                                <p className='mt-2 text-sm leading-relaxed text-muted-foreground'>
                                    {proof.text}
                                </p>
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </Container>
        </section>
    )
}
